import { render, staticRenderFns } from "./SatelliteImageReferenceWithStats.vue?vue&type=template&id=d5aa631c&lang=html&"
import script from "./SatelliteImageReferenceWithStats.vue?vue&type=script&lang=js&"
export * from "./SatelliteImageReferenceWithStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports